// extracted by mini-css-extract-plugin
export default {"topbarLink":"BecomeAnExpertLink_topbarLink__dBs5j","topbarLinkLabel":"BecomeAnExpertLink_topbarLinkLabel__i9PqD textSmall","special":"BecomeAnExpertLink_special__b2KVy"};